import { Container, Row, Col } from "react-bootstrap";
import profileImg from "../asset/img/profile_picture.jpeg";
import image2 from "../asset/img/image2.jpg";
import image3 from "../asset/img/image3.jpg";
import image4 from "../asset/img/image4.jpg";

export const About = () => {
    const images = [profileImg, image2, image3, image4];

    return (
        <div className="about" id="about">
            <Container>
                <Row className="align-items-center">
                    <Col xs={12} md={6} xl={7}>
                        <div className="image-accordion">
                            {images.map((image, index) => (
                                <img
                                    key={index}
                                    src={image}
                                    alt={`Accordion Img ${index + 1}`}
                                    className="accordion-image"
                                />
                            ))}
                        </div>
                    </Col>
                    <Col xs={12} md={6} xl={5}>
                        <h1>About</h1>
                        <p>
                            I am a motivated Computer Science student at Georgia Tech with a passion for software development and AI.
                            I am eager to leverage my technical skills and problem-solving abilities to build innovative solutions in a collaborative environment.
                        </p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};
